// extracted by mini-css-extract-plugin
export default {"divider":"LoginForm_divider__yOrJF"};